import { FC } from 'react';
import { useSeoBlockContext } from '../hooks';
import { SeoBlockCity } from './SeoBlockCity';
import seoBlockLinkList from '../assets/seo-block-link-list.module.scss';

const SeoBlockCityList: FC = () => {
  const { cityList } = useSeoBlockContext();

  if (!cityList || cityList.length === 0) {
    return null;
  }

  const cityElementList = cityList.map((city) => (
    <SeoBlockCity key={city.link.to} city={city} />
  ));

  return (
    <div className={seoBlockLinkList.seoBlockLinkList}>
      {cityElementList}
    </div>
  );
};

export { SeoBlockCityList };
